import {
  CircleDashed, Clock, CheckCircle2, BadgeCheck, XCircle, UserX, Lock,
} from "lucide-react";

// Estado → { label, icon, text color, badge bg, dot color }
export const PHYSIO_STATUS = {
  available: { label: "Libre", icon: CircleDashed, cls: "text-slate-500", badge: "bg-slate-100 text-slate-600 border-slate-200" },
  booked: { label: "Reservada", icon: Clock, cls: "text-blue-600", badge: "bg-blue-50 text-blue-700 border-blue-200" },
  confirmed: { label: "Confirmada", icon: CheckCircle2, cls: "text-emerald-600", badge: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  completed: { label: "Completada", icon: BadgeCheck, cls: "text-cyan-600", badge: "bg-cyan-50 text-cyan-700 border-cyan-200" },
  cancelled: { label: "Cancelada", icon: XCircle, cls: "text-rose-600", badge: "bg-rose-50 text-rose-700 border-rose-200" },
  no_show: { label: "No presentado", icon: UserX, cls: "text-rose-700", badge: "bg-rose-100 text-rose-800 border-rose-300" },
  blocked: { label: "Bloqueada", icon: Lock, cls: "text-slate-600", badge: "bg-slate-200 text-slate-700 border-slate-300" },
};

// Estados administrativos visibles al entrenador (sin datos clínicos)
export const COACH_STATUS_LABEL = {
  booked: "Programada",
  confirmed: "Confirmada",
  completed: "Completada",
  cancelled: "Cancelada",
};

export const WEEKDAY_NAMES = ["lunes", "martes", "miércoles", "jueves", "viernes", "sábado", "domingo"];

export function isoToday() {
  return new Date().toISOString().slice(0, 10);
}

// Lunes de la semana que contiene `iso`
export function mondayOf(iso) {
  const d = new Date(iso + "T00:00:00");
  const wd = (d.getDay() + 6) % 7; // 0 = lunes
  d.setDate(d.getDate() - wd);
  return d.toISOString().slice(0, 10);
}

export function addDays(iso, n) {
  const d = new Date(iso + "T00:00:00");
  d.setDate(d.getDate() + n);
  return d.toISOString().slice(0, 10);
}

export function fmtDateEs(iso) {
  if (!iso) return "";
  const d = new Date(iso + "T00:00:00");
  return d.toLocaleDateString("es-ES", { day: "numeric", month: "long", year: "numeric" });
}

export function isoWeekNumber(iso) {
  const d = new Date(iso + "T00:00:00");
  const target = new Date(d.valueOf());
  const dayNr = (d.getDay() + 6) % 7;
  target.setDate(target.getDate() - dayNr + 3);
  const firstThursday = target.valueOf();
  target.setMonth(0, 1);
  if (target.getDay() !== 4) {
    target.setMonth(0, 1 + ((4 - target.getDay()) + 7) % 7);
  }
  return 1 + Math.ceil((firstThursday - target) / 604800000);
}
